import { call, put, takeLatest } from 'redux-saga/effects'
import {RESEND_EMAIL_REQUEST, USER_CREATE_REQUEST} from './constants';
import { getUserCreateFailureAction,
		getUserCreateSuccessAction,
		resendEmailFailure,
		resendEmailSuccess
} from "./actions";
import remote from '../../../../services/remote'
import SentryManager from "../../../../monitoring/Sentry";

function* createUser (action) {
    try {
        const response = yield call(remote, {
            route: '/entrance/signup',
            method: 'post',
            body: JSON.stringify(action.data.user)
        });
        if (response.success) {
            yield put(getUserCreateSuccessAction(response.data));
        } else {
            yield put(getUserCreateFailureAction(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

function* resendEmail (action) {
    try {
        const response = yield call(remote, {
            route: '/entrance/resend',
            method: 'post',
            body: JSON.stringify({email: action.data})
        });
        if (response.success) {
            yield put(resendEmailSuccess(response.data));
        } else {
            yield put(resendEmailFailure(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

export default function* watchRegisterSaga() {
    yield takeLatest(USER_CREATE_REQUEST, createUser);
    yield takeLatest(RESEND_EMAIL_REQUEST, resendEmail);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Register/saga.js